import { useOnline } from '@iris/ui/hooks/use-online';
import { WifiOff } from 'lucide-react';

/** Top banner while offline (T4 §2.4, §4.6). The message is translated by the app. */
export function OfflineBanner({ message }: { message: string }) {
  const online = useOnline();
  if (online) return null;
  return (
    <div
      role="status"
      className="sticky top-0 z-40 flex items-center justify-center gap-2 bg-warning-600 px-4 py-2 text-sm font-medium text-white"
    >
      <WifiOff aria-hidden className="h-4 w-4 shrink-0" />
      <span>{message}</span>
    </div>
  );
}
